
<template>
    <a  :href="collectionUrl" class="viewer-item-collection-link" :title="titleName" data-testid="viewer-item-collection-link">
        <div class="back-to-collection">
          <i class="fa fa-arrow-left"></i>
          <span class="collection-item-name">
           {{collectionName | truncate(20)}}
          </span>
        </div>
    </a> 
</template>


<script>
export default {
  props: {
    collectionName: String,
    collectionUrl: String
  },
  computed: {
    titleName: function() {
      return "Back to "+ this.collectionName
    },
  },
  filters: {
    truncate: function (text, length) {
        if (text.length > length) {
            return text.substring(0, length) + '...';
        } else {
            return text;
        }
    },
  }
}
</script>
